module.exports = __webpack_public_path__ + "img/pakiet.2d43c496.jpg";